"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ElementalShockSonicAbilityHandler = exports.ElementalShockSonicActorAbilityFactory = exports.ElementalShockSonicAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const EventType_1 = require("../../core/events/EventType");
const Schedule_1 = require("../../core/Schedule");
class ElementalShockSonicAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.ElementalShockSonic;
        this.__typeName = "ElementalShockSonic";
    }
}
exports.ElementalShockSonicAbilityArgs = ElementalShockSonicAbilityArgs;
let ElementalShockSonicActorAbilityFactory = class ElementalShockSonicActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("ElementalShockSonic", "Self", 0);
    }
};
ElementalShockSonicActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("ElementalShockSonic")
], ElementalShockSonicActorAbilityFactory);
exports.ElementalShockSonicActorAbilityFactory = ElementalShockSonicActorAbilityFactory;
let ElementalShockSonicAbilityHandler = class ElementalShockSonicAbilityHandler {
    init(sequence, container, actorId) {
        const ownerId = container.getActor(actorId).ownerId;
        container.applyBuff({
            sequence,
            creatorId: actorId,
            targetId: actorId,
            duration: Duration_1.Duration.Permanent,
            effect: new core_1.LinkedEventHandlerEffectArgs("Elemental Shock: Sonic", "Sonic pulses killer", false, container.registerEventHandlerScript(actorId, EventType_1.EventType.Killed, Schedule_1.Schedule.Once(), "ApplyEffects_OnKilled", {
                target: "killer",
                effects: [{
                        duration: Duration_1.Duration.Ticks(8),
                        effect: new core_1.SonicPulseEffectArgs("Focus", 20),
                        percentChance: 100
                    }]
            })),
            supernatural: true,
        });
    }
    activate(sequence, container, ability) {
        throw new Error("PASSIVE_ONLY");
    }
};
ElementalShockSonicAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.ElementalShockSonic)
], ElementalShockSonicAbilityHandler);
exports.ElementalShockSonicAbilityHandler = ElementalShockSonicAbilityHandler;
